<template>
  <el-card
    style="height: 99%; overflow: auto"
    class="box-card"
    :body-style="{ height: '85%' }"
  >
    <div slot="header" class="FCC">
      <div class="FC">
        <!-- <img src="../../../assets/img/icon_title.svg" alt="" /> -->
        <span class="CH_FontSty">构件追踪模型配置</span>
      </div>
      <div class="FC" style="margin-right: 32px"></div>
    </div>
    <el-row style="height: 100%">
      <el-col :span="4" style="height: 100%">
        <div class="treeStyle">
          <el-button
            type="primary"
            size="small"
            style="margin-top: 15px"
            @click="getTraceseList('all')"
            >显示全部</el-button
          >
          <zTree
            :zNodes="zNodes"
            @getData="getTraceseList"
            @addZtree="addZtree"
            @delZtree="delZtree"
            @EditName="EditName"
            @dropTree="dropTree"
            :changeInit="true"
            :options="{
              id: 'ctst01',
              pid: 'ctst06',
              label: 'ctst03',
              zTreeId: 'tarckingTree',
              delType: {
                add: true,
                update: true,
                del: true,
              },
            }"
            ref="zTree"
          />
        </div>
      </el-col>
      <el-col :span="20" style="padding-left: 40px; height: 100%">
        <el-table
          stripe
          :header-cell-style="{
            background: '#EBEFF2',
            color: '#1E2134',
            fontWeight: 'bold',
          }"
          :data="tableData"
          style="width: 100%"
        >
          <el-table-column
            align="center"
            type="index"
            label="序号"
            width="80"
          ></el-table-column>
          <el-table-column prop="ctst03" align="center" label="配置名称">
          </el-table-column>
          <el-table-column prop="modelname" align="center" label="模型名称">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="small"
                @click="editProject(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                size="small"
                @click="delProject(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          style="float: right"
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pageIndex"
          :page-size="pageSize"
          layout="sizes,total,prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination
      ></el-col>
    </el-row>

    <!-- 添加模型 -->
    <el-dialog title="添加模型" :visible.sync="InsertModelVisible" width="30%">
      <el-form ref="Form" label-width="80px">
        <el-form-item label="配置名称">
          <el-input
            style="width: 400px"
            v-model="ConfigName"
            placeholder="请输入配置名称"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="选择模型">
          <el-select
            style="width: 400px"
            v-model="ConfigModel"
            placeholder="请选择模型"
            filterable
          >
            <el-option
              v-for="item in optionsList"
              :key="item.mode01"
              :label="item.mode02"
              :value="item.mode01"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="InsertModelVisible = false">取 消</el-button>
        <el-button type="primary" @click="InsertModeldeter()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 编辑模型 -->
    <el-dialog title="编辑模型" :visible.sync="EditModelVisible" width="30%">
      <el-form ref="editform" :model="EditForm" label-width="80px">
        <el-form-item label="配置名称">
          <el-input
            style="width: 400px"
            v-model="EditForm.EConfigName"
            placeholder="请输入配置名称"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="选择模型">
          <el-select
            style="width: 400px"
            v-model="EditForm.EConfigModel"
            placeholder="请选择模型"
            filterable
          >
            <el-option
              v-for="item in optionsList"
              :key="item.mode01"
              :label="item.mode02"
              :value="item.mode01"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EditModelVisible = false">取 消</el-button>
        <el-button type="primary" @click="EditModeldeter('editform')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  GetComponenttracesetList,
  InsertComponenttraceset,
  DeleteComponenttraceset,
  UpdateComponenttraceset,
  GetModelList,
  ChangeComponenttraceOrder,
} from "@/setAxios";

import zTree from "@/components/zTree";
export default {
  components: { zTree },
  data() {
    return {
      zNodes: null,
      tableData: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      InsertModelVisible: false,
      EditModelVisible: false,
      ConfigName: "",
      ConfigModel: "",
      optionsList: [],
      EditForm: {
        Eid: "",
        EConfigName: "",
        EConfigModel: "",
      },
      pid: 0,
      changeTrack: {},
      ids: "",
    };
  },
  created() {
    this.getTraceseList("all");
    this.getModelList();
  },
  methods: {
    async dropTree(data) {
      let res = await ChangeComponenttraceOrder(data);
      if (res.Code) this.$message.success("修改成功");
    },
    async addZtree(id) {
      this.pid = id;
      this.InsertModelVisible = true;
    },
    async delZtree(id) {
      this.delProject({ ctst01: id, pass: true });
    },
    async EditName(row) {
      this.EditForm.Eid = row.ctst01;
      this.EditForm.EConfigName = row.ctst03;
      this.EditForm.EConfigModel = row.ctst04;
      this.EditModelVisible = true;
      this.changeTrack = row;
    },
    //获取构建追踪列表
    async getTraceseList(val) {
      if (val == "all" || val == undefined) {
        this.ids = "";
      } else {
        this.ids = val;
      }
      let params = {
        seachword: "",
        pageIndex: this.ids == "" ? 1 : this.pageIndex,
        pageSize: this.ids == "" ? 99999 : this.pageSize,
        pid: this.$store.state.xid,
        ids: this.ids,
      };
      let res = await GetComponenttracesetList(params);
      // ids 如果‘’ 查全部过滤数据ztree 和 所有的子节点右边显示
      if (this.ids == "") {
        this.zNodes = res.Data.list.filter((ele) => {
          let bol = false;
          this.tableData = [];
          res.Data.list.forEach((ele2) => {
            if (ele.ctst01 == ele2.ctst06 || ele2.ctst06 == 0) {
              // 这是个树节点
              bol = true;
            } else {
              // 这是个构件追踪配置
              this.tableData.push(ele);
            }
          });
          return bol;
        });
      }
      this.tableData = res.Data.list;
      this.total = res.Data.total;
    },
    //获取模型列表
    getModelList() {
      let params = {
        xid: this.$store.state.xid,
        searchword: "",
        pageIndex: 1,
        pageSize: 1000,
      };
      GetModelList({ params }).then((res) => {
        this.optionsList = res.Data.list;
      });
    },
    //添加构建追踪
    async InsertModeldeter() {
      if (this.ConfigName == "" || this.ConfigModel == "") {
        this.$message({
          type: "warning",
          message: "请完成选项!",
        });
      } else {
        let params = {
          ctst01: 0,
          ctst02: this.$store.state.xid,
          ctst03: this.ConfigName,
          ctst04: this.ConfigModel,
          ctst05: new Date(),
          ctst06: this.pid,
          ctst07: 0,
        };
        let res = await InsertComponenttraceset(params);
        if (res.Code) {
          this.$message({
            type: "success",
            message: "添加成功!",
          });
          this.getTraceseList();
          this.InsertModelVisible = false;
          this.ConfigName = "";
          this.ConfigModel = "";
        } else {
          this.$message({
            type: "error",
            message: "添加失败!",
          });
          return;
        }
      }
    },
    //删除构建追踪
    async delProject(row) {
      if (row.pass) {
        let params = {
          id: row.ctst01,
        };
        let res = await DeleteComponenttraceset(params);
        if (res.Code) {
          this.$message({
            type: "success",
            message: "移除成功!",
          });
          this.getTraceseList();
        } else {
          this.$message({
            type: "error",
            message: "移除失败!",
          });
        }
      } else {
        this.$confirm("确定删除该项?", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(async () => {
          let params = {
            id: row.ctst01,
          };
          let res = await DeleteComponenttraceset(params);
          if (res.Code) {
            this.$message({
              type: "success",
              message: "移除成功!",
            });
            this.getTraceseList();
          } else {
            this.$message({
              type: "error",
              message: "移除失败!",
            });
          }
        });
      }
    },
    //打开编辑弹窗
    editProject(row) {
      this.EditForm.Eid = row.ctst01;
      this.EditForm.EConfigName = row.ctst03;
      this.EditForm.EConfigModel = row.ctst04;
      this.EditModelVisible = true;
      this.changeTrack = row;
    },
    //编辑确定按钮
    EditModeldeter(editform) {
      this.$refs[editform].validate(async (v) => {
        if (v) {
          let params = {
            ctst01: this.EditForm.Eid,
            ctst02: this.changeTrack.ctst02,
            ctst03: this.EditForm.EConfigName,
            ctst04: this.EditForm.EConfigModel,
            ctst05: this.changeTrack.ctst05,
            ctst06: this.changeTrack.ctst06,
            ctst07: this.changeTrack.ctst07,
          };
          let res = await UpdateComponenttraceset(params);
          if (res.Code) {
            this.$message({
              type: "success",
              message: "编辑成功!",
            });
            this.getTraceseList();
            this.EditModelVisible = false;
          } else {
            this.$message({
              type: "error",
              message: "编辑失败!",
            });
          }
        } else {
          this.$message({
            type: "warning",
            message: "请完成选项!",
          });
        }
      });
    },
    //条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getTraceseList();
    },
    //页数
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getTraceseList();
    },
  },
};
</script>

<style scoped lang="less">
/deep/.el-card__header {
  padding: 18px 0px;
}
/deep/.el-dialog {
  border-radius: 10px;
}
</style>
